import script from "./theme-search.vue?vue&type=script&lang=js"
export * from "./theme-search.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__